{
  "list": {
    "drillRig": "Drill Rig",
    "patternBlast": "Pattern Blast",
    "holesDrilled": "Holes Drilled",
    "metresDrilled": "Metres Drilled",
    "totalHolesDrilled": "Total Holes Drilled:",
    "totalMetresDrilled": "Total Metres Drilled:",
    "noEntries": "No drilling entries during selected shift.",
    "manageEntries": "You can manage drilling entries on the <pageLink>Drilling<icon /></pageLink> page."
  },
  "page": {
    "rigsFailed": "Error while fetching the rigs.",
    "drillingFailed": "Error while fetching the drilling data.",
    "drillLog": "Drill log",
    "drillLogFor": "Drill log for {{rig}}",
    "selectRig": "Select Drill Rig",
    "noRigs": "No Drill Rigs Available",
    "crumb": "BH Drilling"
  },
  "section": {
    "title": "Drilling",
    "none": "No drilling has been created yet.",
    "create": "Create Drilling"
  },
  "summaryTable": {
    "holeType": "Hole Type",
    "bitSize": "Bit Size",
    "holesDrilled": "Holes Drilled",
    "totalMetres": "Total Metres",
    "wet": "Wet",
    "wetHoles": "Wet Holes",
    "redrill": "Redrill",
    "holeTypeRequired": "Hole type is required",
    "bitSizeRequired": "Bit size is required",
    "holesDrilledRequired": "Holes drilled are required",
    "totalMetresRequired": "Total metres are required",
    "added": "Blast hole added successfully",
    "updated": "Blast hole updated successfully",
    "deleted": "Blast hole deleted successfully"
  },
  "patterns": {
    "title": "{{rig}} patterns",
    "modeSummary": "Summary",
    "modeHole": "Hole by hole",
    "modeGroup": "How the holes are recorded",
    "select": "Select Blast Pattern",
    "fetchFailed": "Error while fetching the blast pattern options.",
    "required": "Blast pattern is required",
    "notSavedOffline": "This pattern's holes are not saved on this device, so record it in summary until you reconnect.",
    "added": "Blast pattern added successfully",
    "deleted": "Blast drilling deleted successfully",
    "loadFailed": "The patterns could not be loaded.",
    "loading": "Loading the patterns...",
    "none": "No patterns are recorded for this rig on this shift yet. Choose one above and add it."
  },
  "holePanel": {
    "outcome": "Outcome",
    "depthDrilled": "Depth drilled (m)",
    "bitSize": "Bit size",
    "finished": "Finished",
    "waterEncountered": "Water encountered",
    "recordItAnyway": "Record it anyway?",
    "recordAnyway": "Record anyway",
    "saveChanges": "Save changes",
    "record": "Record",
    "recorded": "{{hole}} recorded",
    "hole": "Hole",
    "depth": "Depth (m)",
    "design": "Design (m)",
    "water": "Water",
    "bit": "Bit",
    "outcomeRedrill": "{{outcome}} · redrill",
    "loadFailed": "The holes for this pattern could not be loaded.",
    "summary": "{{drilled}} of {{total}} holes drilled · {{attempts}} this shift, {{metres}} m",
    "summaryRedrills_one": "{{drilled}} of {{total}} holes drilled · {{attempts}} this shift, {{metres}} m, {{count}} redrill",
    "summaryRedrills_other": "{{drilled}} of {{total}} holes drilled · {{attempts}} this shift, {{metres}} m, {{count}} redrills",
    "drillPlan": "Drill plan for the rig",
    "allDrilledOnSheet": "Every hole on the sheet is drilled",
    "allDrilled": "Every hole is drilled",
    "changingAttempt": "Changing the attempt finished {{time}}.",
    "alreadyStatus": "{{status}} already. Recording it again makes this a redrill.",
    "tapHole": "Tap a hole on the plan, or take the next hole, to record it."
  },
  "meters": {
    "title": "{{rig}} meters",
    "hours": "h",
    "engineHours": "Engine hours",
    "engineReadings": "Start {{start}}, end {{end}}. Entered on the Operations list.",
    "percussionUtilisation": "Percussion utilisation {{percent}}% of engine hours.",
    "start": "Start",
    "end": "End",
    "meterReplaced": "Meter replaced",
    "recordService": "Record service",
    "carriedForward": "Start carried from the last shift's end reading.",
    "serviceEvery": "Service every {{interval}} h; record a service to start counting.",
    "hoursToService": "{{hours}} h to service (every {{interval}} h, last {{date}})",
    "recordServiceTitle": "Record a service",
    "restartsCounting": "{{meter}} start counting again from this service.",
    "servicedOn": "Serviced on",
    "readingAtService": "Meter reading at service",
    "serviceRecorded": "Service recorded"
  },
  "rigReport": {
    "title": "Import the rig's report",
    "intro": "The IREDES quality report the rig wrote after drilling {{reference}}. Its holes are added to this shift; a hole already entered by hand keeps both depths, and the rig's is the one reported.",
    "reading": "Reading the report",
    "dropLabel": "Drag & drop the report (.xml) here, or click to browse",
    "importedTitle": "Rig report imported",
    "result": "{{added}} added, {{merged}} matched to holes already entered.",
    "resultUpdated": "{{added}} added, {{merged}} matched to holes already entered, {{updated}} updated from an earlier import.",
    "resultSkipped": "{{added}} added, {{merged}} matched to holes already entered, {{skipped}} left out.",
    "resultUpdatedSkipped": "{{added}} added, {{merged}} matched to holes already entered, {{updated}} updated from an earlier import, {{skipped}} left out.",
    "done": "Done"
  }
}
